module.exports = {
          srcSet: __webpack_public_path__ + "img/fcb0242-5152.jpg"+" 5152w",
          images:[ {path: __webpack_public_path__ + "img/fcb0242-5152.jpg",width: 5152,height: 3864}],
          src: __webpack_public_path__ + "img/fcb0242-5152.jpg",
          toString:function(){return __webpack_public_path__ + "img/fcb0242-5152.jpg"},
          
          width: 5152,
          height: 3864
        }